import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch'
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

// resource
import VueResource from 'vue-resource';
import { store } from '@/store/store.js';

// router setup
import router from './routes/router';
import i18n from './i18n';
import './registerServiceWorker'

import SEOMeta from './plugins/SEOMeta';
import Recaptcha from './plugins/Recaptcha';
import Turnstile from './plugins/Turnstile';
import LicenseCheck from './plugins/LicenseCheck';

// plugin setup
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);
Vue.use(VueResource);
Vue.use(SEOMeta);
Vue.use(Recaptcha);
Vue.use(Turnstile);
Vue.use(LicenseCheck);
Vue.http.options.root = "api/";

let authInterceptorRegistered = false;
const registerAuthInterceptor = () => {
  if (authInterceptorRegistered) return;
  authInterceptorRegistered = true;
  Vue.http.interceptors.push((request, next) => {
    const token = localStorage.getItem('token');
    request.headers.set('Authorization', token || '');
    request.headers.set('Accept', 'application/json');
    next();
  });
};

registerAuthInterceptor();

router.beforeEach(async (to, from, next) => { // https://router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards
  if (localStorage.getItem('token') == null &&
    to.path != '/login' &&
    to.path != '/register' &&
    to.path != '/registered' &&
    to.path != '/confirmation' &&
    to.path != '/reset' &&
    to.path != '/logout'
  ) {
    next('/login');
  } else {
    // Check if user profile is loaded, if not fetch it
    if (localStorage.getItem('token') && (!store.state.resources.me || !store.state.resources.me.type)) {
      try {
        await store.dispatch('apiResources');
      } catch (e) {
        // If fetch fails (e.g. invalid token), let the API interceptor or next guard handle it,
        // typically 401/403 would redirect to login eventually.
      }
    }

    // Admin Access Check
    if (to.matched.some(record => record.meta.adminOnly)) {
      const userType = store.state.resources.me ? store.state.resources.me.type : null;
      // Assuming 'Client' and 'Reseller' are the non-admin types.
      if (userType === 'Client' || userType === 'Reseller') {
        // Redirect to user dashboard or safe area
        next('/my/orders');
        return;
      }
    }

    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  i18n,
  mounted() {
    // Fetch and apply SEO settings globally
    this.$http.get('settings')
      .then(response => response.json())
      .then(settings => {
        this.$seo.apply(settings);
        // Initialize reCAPTCHA v3 if configured
        const recaptchaKey = settings.find(s => s.id === 'recaptchaSiteKey');
        if (recaptchaKey && recaptchaKey.value) {
          this.$recaptcha.init(recaptchaKey.value);
        }
        // Initialize Cloudflare Turnstile if configured
        const turnstileKey = settings.find(s => s.id === 'turnstileSiteKey');
        if (turnstileKey && turnstileKey.value) {
          this.$turnstile.init(turnstileKey.value);
        }
      })
      .catch(err => console.log('SEO/Settings load failed', err));
  }
});
